<script>
    import * as yup from 'yup';
    import {user} from "../auth/auth";

    let awsErrors;
    let values = {
        email: "",
        password: "",
        confirmPassword: "",
    };

    const schema = yup.object().shape({
        email: yup.string().required("Email is required").email("Email is invalid"),
        password: yup.string().required("Password is required"),
        confirmPassword: yup.string().required("Please confirm your password")
            .oneOf([yup.ref("password"), null], "Passwords do not match"),
    });

    let errors = {};

    const handleSubmit = async () => {
        errors = {};
        try {
            await schema.validate(values, { abortEarly: false })
        } catch (err) {
            errors = err.inner.reduce((acc, err) => {
                return  { ...acc, [err.path]: err.message };
            }, {});
        }
        if (Object.keys(errors).length === 0) {
            handleRegister(values.email, values.password)
        }
    };

    function handleRegister(email, password) {
        var onFailure = (e) => {
            awsErrors = e;
        };
        user.register(email, password, onFailure);
    }

</script>

<section class="form-wrap" >
    <form on:submit|preventDefault={handleSubmit}>
        <fieldset class="form-fs">
            <h2 class="fs-title">Create your account</h2>
            {#if errors.email}
                <span class="error">{errors.email}</span>
            {/if}
            <input name="email" type="email" bind:value={values.email} placeholder="Email" />
            {#if errors.password}
                <span class="error">{errors.password}</span>
            {/if}
            <input name="password" type="password" bind:value={values.password} placeholder="Password" pattern=".*" />
            {#if errors.confirmPassword}
                <span class="error">{errors.confirmPassword}</span>
            {/if}
            <input name="confirmPassword" type="password" bind:value={values.confirmPassword} placeholder="Confirm Password" pattern=".*" />

            {#if awsErrors}
                <div class="error">{awsErrors.message}</div>
            {/if}

            <button class="form-button" type="submit" >Submit</button>
        </fieldset>
    </form>
</section>


<style>
    .form-wrap {
        background-color: #202020;
        color: #FBF8FE;
        display: flex;
        flex: 1;
        flex-direction: column;
        margin: 10vh;
        border-radius: 6px;
    }
    .form-fs {
        font-size: 3vw;
        font-family: "Poppins", "Arial", "Helvetica Neue", sans-serif;
        padding-top: 0;
        padding-left: 7vw;
        padding-right: 7vw;
        border: none;
    }
    .form-button {
        margin-top: 4vh;
        border-radius: 6px;
        color: #0B8185;
    }
    .form-button:hover {
        cursor: pointer;
    }
    .error {
        display: flex;
        flex: 1;
        font-size: 1.5vw;
        color: #E5394F;
    }
    input {
        width: 100%;
        padding: 5px 0;
        font-size: 4vw;
        color: #ccc;
        background: transparent;
        outline: none;
        margin: 0;
        border: none;
        margin-bottom: 33px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    }
</style>